// Мок-данные для клона Bullets Poker Clock
// Этот файл имитирует backend, пока не выполнена интеграция.

export const DEFAULT_BLIND_STRUCTURE = [
  { level: 1, sb: 100, bb: 200, ante: 0, duration: 20, isBreak: false },
  { level: 2, sb: 200, bb: 400, ante: 0, duration: 20, isBreak: false },
  { level: 3, sb: 300, bb: 600, ante: 0, duration: 20, isBreak: false },
  { level: 4, sb: 400, bb: 800, ante: 100, duration: 20, isBreak: false },
  { level: 5, sb: 500, bb: 1000, ante: 100, duration: 20, isBreak: false },
  { level: 0, sb: 0, bb: 0, ante: 0, duration: 10, isBreak: true, breakLabel: 'Перерыв' },
  { level: 6, sb: 600, bb: 1200, ante: 200, duration: 20, isBreak: false },
  { level: 7, sb: 800, bb: 1600, ante: 200, duration: 20, isBreak: false },
  { level: 8, sb: 1000, bb: 2000, ante: 300, duration: 20, isBreak: false },
  { level: 9, sb: 1500, bb: 3000, ante: 400, duration: 20, isBreak: false },
  { level: 10, sb: 2000, bb: 4000, ante: 500, duration: 20, isBreak: false },
  { level: 0, sb: 0, bb: 0, ante: 0, duration: 15, isBreak: true, breakLabel: 'Ужин' },
  { level: 11, sb: 3000, bb: 6000, ante: 1000, duration: 15, isBreak: false },
  { level: 12, sb: 4000, bb: 8000, ante: 1000, duration: 15, isBreak: false },
  { level: 13, sb: 5000, bb: 10000, ante: 2000, duration: 15, isBreak: false },
  { level: 14, sb: 8000, bb: 16000, ante: 2000, duration: 15, isBreak: false },
  { level: 15, sb: 10000, bb: 20000, ante: 3000, duration: 15, isBreak: false },
];

export const SAMPLE_TOURNAMENTS = [
  {
    id: 'tour-1',
    code: '48291',
    name: 'Пятничный Дипстек',
    subtitle: 'Ежемесячный турнир спортивного покерного клуба',
    descriptionLines: [
      'Стартовый стек: 20 000 фишек',
      'Ре-энтри до 6-го уровня',
      'Победитель получает кубок'
    ],
    sideInfo: 'Первый турнир месяца!\n\nПобедитель получает главный кубок клуба и путёвку на региональный чемпионат.\n\nБуфет открыт до 23:00.',
    currency: 'очки',
    startingStack: 20000,
    buyIn: 0,
    players: {
      total: 42,
      remaining: 28,
      reentries: 6,
      addons: 4
    },
    currentLevelIndex: 3,
    timeRemainingSec: 720,
    isPaused: false,
    isRunning: true,
    blinds: DEFAULT_BLIND_STRUCTURE,
    createdAt: '2026-06-01T18:00:00Z'
  },
  {
    id: 'tour-2',
    code: '73104',
    name: 'Воскресный Ребай',
    subtitle: 'Отборочный этап чемпионата клуба',
    descriptionLines: [
      'Стартовый стек: 15 000 фишек',
      'Безлимитные ребаи в первые 2 часа',
    ],
    currency: 'очки',
    startingStack: 15000,
    buyIn: 0,
    players: {
      total: 24,
      remaining: 24,
      reentries: 0,
      addons: 0
    },
    currentLevelIndex: 0,
    timeRemainingSec: 1200,
    isPaused: true,
    isRunning: false,
    blinds: DEFAULT_BLIND_STRUCTURE,
    createdAt: '2026-06-08T18:00:00Z'
  }
];

export const MOCK_USER = {
  id: 'admin-1',
  email: 'admin@club.local',
  password: 'admin123',
  name: 'Организатор турнира'
};

export const FAQ_ITEMS = [
  {
    q: 'Как работает Bullets Poker Clock?',
    a: 'Создайте турнир в админ-панели, настройте структуру блайндов, игроков и перерывы. Генерируется уникальный 2-значный код. Введите его на любом устройстве, чтобы вывести часы на телевизоры, планшеты или телефоны.'
  },
  {
    q: 'Можно ли управлять часами с нескольких устройств?',
    a: 'Да. Как администратор, вы можете ставить на паузу, возобновлять, переключать уровни, добавлять игроков и корректировать перерывы с любого устройства. Изменения мгновенно передаются на все подключённые экраны.'
  },
  {
    q: 'Это бесплатно для спортивных покерных клубов?',
    a: 'Да. Наши спортивные покерные клубы (без игры на деньги) могут пользоваться всеми функциями часов бесплатно. Просто создайте аккаунт и начните первый турнир.'
  },
  {
    q: 'Нужно ли устанавливать приложение?',
    a: 'Установка не требуется. Всё работает в браузере на телевизоре, телефоне, планшете или ноутбуке.'
  },
  {
    q: 'Можно ли настроить звуковые оповещения?',
    a: 'Да, вы можете выбирать из встроенных сигналов и гудков, которые звучат при смене уровня и начале/окончании перерыва.'
  }
];

export const HOW_IT_WORKS_STEPS = [
  {
    step: 1,
    title: 'Создайте турнир',
    text: 'Задайте название, подзаголовок, строки описания, уровни блайндов и перерывы в админ-панели.'
  },
  {
    step: 2,
    title: 'Получите 2-значный код',
    text: 'Каждому турнирному циферблату присваивается уникальный 2-значный код, которым можно мгновенно поделиться.'
  },
  {
    step: 3,
    title: 'Выведите на любой ТВ',
    text: 'Откройте bullets clock в браузере телевизора, введите код и разверните на весь экран. Готово за секунды.'
  },
  {
    step: 4,
    title: 'Управляйте турниром',
    text: 'Ставьте на паузу, продолжайте, пропускайте уровни, добавляйте игроков со своего телефона. Экран обновляется мгновенно.'
  }
];

export const PRICING = [
  {
    name: 'Спортивный клуб',
    price: 'Бесплатно',
    period: 'навсегда',
    features: [
      'Неограниченные турниры',
      'До 5 сохранённых циферблатов',
      'Редактор структуры блайндов',
      'Обмен 2-значным кодом',
      'Звуковые оповещения'
    ],
    highlight: false,
    cta: 'Начать бесплатно'
  },
  {
    name: 'Pro клуб',
    price: '9 €',
    period: 'в месяц',
    features: [
      'Всё из тарифа «Спортивный клуб»',
      'Неограниченные сохранённые циферблаты',
      'Свой логотип и цвета клуба',
      'Рекламные блоки на ТВ-экране',
      'Приоритетная поддержка'
    ],
    highlight: true,
    cta: 'Перейти на Pro'
  },
  {
    name: 'Казино',
    price: 'Индивидуально',
    period: 'по запросу',
    features: [
      'Всё из тарифа «Pro клуб»',
      'Выплаты и призовой фонд',
      'Многодневные турниры',
      'Помощь при установке на месте'
    ],
    highlight: false,
    cta: 'Связаться с нами'
  }
];
